<template>

    <div :id="'sparkchart-'+resource+mode" class="spark-chart"></div>
</template>

<script>
    import * as am4core from '@amcharts/amcharts4/core';
    import * as am4charts from '@amcharts/amcharts4/charts';
    import ApexCharts from 'apexcharts'

    export default {
        name: 'SparkChart',
        props: {
            resource: Number,
            mode: String
        },
        mounted() {
            var rid = this.resource;
            fetch('https://sc.gamers-universe.eu/api/getHistory.php?mode='+this.mode+'&id='+rid, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                },
            }).then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
                .then(response => {

                    let dateData = [];
                    let valueData = [];
                    _.forEach(response, function(item, key) {
                        dateData.push(item.cdate);
                        valueData.push(item.daymin);
                    })
                    var options = {
                        chart: {
                            type: 'line',
                            height: 50,
                            sparkline: {
                                enabled: true,
                            }
                        },
                        stroke: {
                            curve: 'smooth',
                            width: 1,
                        },
                        series: [{
                            name: 'price',
                            data: valueData
                        }],
                        xaxis: {
                            categories: dateData
                        }
                    }
                    var chart = new ApexCharts(document.querySelector("#sparkchart-"+rid+this.mode), options);
                    chart.render();
                  /*  var chart = am4core.create("sparkchart-"+rid+this.mode, am4charts.XYChart);

                    chart.padding(0, 0, 0, 0);

                    chart.data = response;
                    var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                    dateAxis.renderer.grid.template.disabled = true;
                    dateAxis.renderer.labels.template.disabled = true;
                    dateAxis.startLocation = 0.5;
                    dateAxis.endLocation = 0.7;
                    dateAxis.cursorTooltipEnabled = false;

                    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                    //valueAxis.min = 0;
                    valueAxis.renderer.grid.template.disabled = true;
                    valueAxis.renderer.baseGrid.disabled = true;
                    valueAxis.renderer.labels.template.disabled = true;
                    valueAxis.cursorTooltipEnabled = false;

                    chart.cursor = new am4charts.XYCursor();
                    chart.cursor.lineY.disabled = true;

                    var series = chart.series.push(new am4charts.LineSeries());
                    series.tooltipText = "{cdate}: [bold]{daymin}";
                    series.dataFields.dateX = "cdate";
                    series.dataFields.valueY = "daymin";
                    series.tensionX = 0.8;
                    series.strokeWidth = 2;

// render data points as bullets
                    var bullet = series.bullets.push(new am4charts.CircleBullet());
                    bullet.circle.opacity = 0;
                    bullet.circle.propertyFields.opacity = "opacity";
                    bullet.circle.radius = 3;*/
                })

        },
    };
</script>

<style scoped lang="scss">

    .spark-chart {
        max-height: 40px;
    }
</style>
